import { useQuery } from "@tanstack/react-query"
import axios from "axios"

interface UseAutomationListQueryProps {
    companyAutomationId?: string
}
interface SecondaryAutomation {
    companyAutomationId: string
    name: string
}

interface SecondaryAutomationFormValuesResponse {
    SECONDARY_AUTOMATION: Array<SecondaryAutomation>
}

export const DEFAULT_SECONDARY_AUTOMATIONS_DATA = {
    SECONDARY_AUTOMATION: [],
} as SecondaryAutomationFormValuesResponse

export default function useSecondaryAutomationFormValuesQuery({
   companyAutomationId,
}: UseAutomationListQueryProps) {
    return useQuery({
        queryKey: ['secondaryAutomation', companyAutomationId],
        queryFn: async () => {
            const GET_LINKABLE_SECONDARY_AUTOMATION_ENDPOINT = '/admin/action/automation/admin/linkable';
            const { data } = await axios.get(GET_LINKABLE_SECONDARY_AUTOMATION_ENDPOINT, {
                params: {
                    companyAutomationId: companyAutomationId,
                }
            })
            return {
                SECONDARY_AUTOMATION: data.COMPANY_AUTOMATIONS
            }
        },
    })
}